export const operationalStep = (operationalStateId) => {
  if (operationalStateId === 0)
    return 1;
  if (operationalStateId === 7)
    return 5;
};